import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMemberClub } from "src/models/Customers/MemberClub.models";

interface MemberClubState {
  memberClubs: IMemberClub[];
  memberClubToEdit: IMemberClub | null;
}

const initialState: MemberClubState = {
  memberClubs: [],
  memberClubToEdit: null,
};

const memberClubSlice = createSlice({
  name: "MemberClub",
  initialState,
  reducers: {
    setMemberClubList: (state, action: PayloadAction<IMemberClub[]>) => {
      state.memberClubs = action.payload;
    },
    concatListMemberClub: (
      state: MemberClubState,
      action: PayloadAction<IMemberClub[]>
    ) => {
      state.memberClubs = [...state.memberClubs.concat(action.payload)];
    },
    setMemberClubToEdit: (state, action: PayloadAction<IMemberClub | null>) => {
      state.memberClubToEdit = action.payload;
    },
    addMemberClub: (state, action: PayloadAction<IMemberClub>) => {
      state.memberClubs.push(action.payload);
    },
    updateMemberClub: (state, action: PayloadAction<IMemberClub>) => {
      let itemIndex = state.memberClubs.findIndex(
        item => item.memberClubId === action.payload.memberClubId
      );
      if (itemIndex !== -1) state.memberClubs[itemIndex] = action.payload;
    },
    deleteMemberClub: (state, action: PayloadAction<number>) => {
      const newArray = state.memberClubs.filter(
        item => item.memberClubId !== action.payload
      );
      state.memberClubs = newArray;
    },
  },
});

export const {
  setMemberClubList,
  concatListMemberClub,
  setMemberClubToEdit,
  addMemberClub,
  updateMemberClub,
  deleteMemberClub,
} = memberClubSlice.actions;

export default memberClubSlice.reducer;
